module.exports = __webpack_public_path__ + "img/k_log_logo.22bc5882.jpg";